<template>
  <div class="documentUploaderMain" :style="cssProps">
    <div style="position: relative: height: 0px;">
      <FileUploaderProgress v-if="documentUploader.isUploadInterfaceVisible"
                            :file-objs="documentUploader.files"
                            :is-mime="true"
                            @complete="uploadCompleted"
      />
    </div>
    <div class="topBar">
      <div class="closeBtn" @click="closeDocumentUploader">
        <img src="@/assets/images/close2.png">
      </div>
      <div>Ön izleme</div>
    </div>
    <div class="preview">
      <img :src="getMimeImage(documentUploader.files[0].originalFileName)">
    </div>
    <div class="fileName" @click="toggleInterface">
      {{ documentUploader.files[0].originalFileName }}
    </div>
    <div class="inputBar">
      <input placeholder="Başlık ekle..." v-model="documentUploader.bodyText">
    </div>

    <div class="sendBtnRow">
      <div class="sendBtn" @click="startUploadingFiles">
        <img src="@/assets/images/upload_white.png">
      </div>
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import FileUploaderProgress from '../FileUploaderProgress.vue'
require('@/security.js')
var moment = require('moment')

export default {
  mixins: [messageMixin],

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.previewPage.topBarColor,
        '--bottomBorderColor': this.$config.theme.default.previewPage.bottomBorderColor,
        '--buttonColor': this.$config.theme.default.previewPage.buttonColor
      }
    }
  },
  props: {
    documentUploader: {
      type: Object,
      default: function () {
        return {}
      }
    },
    conversationID: {
      type: String,
      default: ''
    }
  },

  methods: {
    toggleInterface () {
      this.documentUploader.isUploadInterfaceVisible = true
    },

    closeDocumentUploader () {
      this.$store.commit('setActiveConversationDocumentUploaderFiles', [])
      this.$store.commit('setActiveConversationDocumentUploaderVisibility', false)
    },

    openFileDialog () {
      this.$refs.documentFileSelector.click()
    },

    documentFilesSelected () {
      let inputFiles = []

      for (let file of this.$refs.documentFileSelector.files) {
        let mod = JSON.parse(
          JSON.stringify(this.$store.state.message.uploadFileModel)
        )
        mod.file = file
        mod.originalFileName = file.name
        mod.processId = this.$uuid.v4()
        mod.uploadUrl = process.env.VUE_APP_UPLOADURL
        inputFiles.push(mod)
      }

      this.$store.commit(
        'appendActiveConversationDocumentUploaderFiles',
        inputFiles
      )

      this.$refs.documentFileSelector.value = ''
    },

    startUploadingFiles () {
      const activeConv = this.$store.state.conversation.activeConversation;
      if (activeConv && activeConv.newMessage) {
        activeConv.newMessage.Body = null;
      }
      this.documentUploader.isUploadInterfaceVisible = true
    },

    uploadCompleted () {
      let urls = this.documentUploader.files.map(x => x.resultURL)
      this.documentUploader.isVisible = false
      this.documentUploader.isUploadInterfaceVisible = false
      this.addDocumentMessageFromMe(urls)
    },

    addDocumentMessageFromMe (documentUrls) {
      var newMsg = JSON.parse(
        JSON.stringify(
          this.$store.state.conversation.activeConversation.newMessage
        )
      )
      newMsg.MessageID = this.$uuid.v4()
      newMsg.CreateDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.UpdateDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      newMsg.From = this.$store.state.session.user.UserID
      if (
        this.$store.state.conversation.activeConversation.isGroupConversation ===
          true
      ) {
        newMsg.To = this.$store.state.conversation.activeConversation.GroupID
        newMsg.ConversationID = ''
        newMsg.isGroup = true
        newMsg.ConversationType = 1
      } else if (this.$store.state.conversation.activeConversation.isChannelConversation === true) {
        newMsg.To = this.$store.state.conversation.activeConversation.ChannelID
        newMsg.ConversationID = ''
        newMsg.isGroup = false
        newMsg.ConversationType = 2
      } else {
        newMsg.To = this.$store.state.conversation.activeConversation.ContactID
        newMsg.ConversationID = this.$store.state.conversation.activeConversation.ConversationID
        newMsg.ConversationType = 0
      }
      newMsg.MessageType = 100
      newMsg.MediaURLs = documentUrls
      newMsg.Body = this.documentUploader.bodyText
      newMsg.DeleteStatus = 0

      if (this.$store.state.ien) {
        this.$set(newMsg, 'mv', 2)// encryption update
        this.em(newMsg)
      }

      this.$store.dispatch('appendMessages', [newMsg])
      this.$store.dispatch('clearActiveNewMessage')

      this.sendMessage(newMsg)

      this.documentUploader.bodyText = ''
    },

    getMimeImage (documentName) {
      let documentExtension = documentName.split('.').pop()
      return '/images/mimes/' + documentExtension + '.png'
    }
  },
  components: {
    FileUploaderProgress
  },

  watch: {
    conversationID: {
      // eslint-disable-next-line
        handler: function (val, oldVal) {
      },
      deep: false
    }
  },

  mounted () {
    this.documentUploader.bodyText = this.documentUploader.files[0].originalFileName
  }
}

</script>

<style scoped>
  .documentUploaderMain {
    width: 100%;
    height: calc(100% - 60px);
    position: absolute;
    top: 60px;
    left: 0px;
    background-color: white;
    z-index: 900000;
    display: flex;
    flex-direction: column;
  }

  .topBar {
    background-color: var(--topBarColor);
    padding: 10px;
    color: white;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .closeBtn,
  .closeBtn>img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }

  .closeBtn {
    margin-right: 10px;
  }

  .preview {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    padding: 150px;
    justify-content: center;
  }

  .preview>img {
    object-fit: contain;
    max-width: 150px;
    max-height: 150px;
    justify-content: center;
  }

  .fileName {
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }

  .inputBar {
    padding: 10px;
    background-color: rgb(241, 241, 241);
    height: 100px;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inputBar>input {
    height: 30px;
    width: 70%;
    border: none;
    background-color: rgba(0, 0, 0, 0);
    border-bottom: 1px solid var(--bottomBorderColor);
    font-size: 14px;
    font-weight: 300;
  }

  .inputBar>input:focus {
    outline: none;
  }

  .thumbsRow {
    min-height: 100px;
    background-color: #d1d1d1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-shrink: 0;
    overflow-x: scroll;
  }

  .thumbsRow::-webkit-scrollbar {
    height: 3px;
  }

  .thumbsRow::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }

  .thumbDocument {
    width: 100px;
    height: 100px;
    margin: 10px;
    margin-left: 0px;
    border: 0px solid white;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .selectedThumb {
    border: 4px solid white;
    width: 92px;
    height: 92px;
  }

  .addNewFileButton {
    width: 100px;
    height: 100px;
    margin: 10px;
    margin-left: 0px;
    background-color: white;
    cursor: pointer;
    font-weight: 700;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .addNewFileButton>img {
    width: 20px;
    height: 20px;
    margin-bottom: 15px;
  }

  .sendBtnRow {
    height: 0px;
    display: flex;
    position: relative;
  }

  .sendBtn {
    background-color: var(--buttonColor);
    position: absolute;
    top: -145px;
    right: 30px;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
  }

  .sendBtn>img {
    width: 25px;
    height: 25px;
  }

  .removeDocumentFromList {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s ease;
  }

  .removeDocumentFromList>img {
    width: 13px;
    height: 13px;
  }

  .thumbDocument:hover+.removeDocumentFromList {
    opacity: 1;
  }

  .removeDocumentFromList:hover {
    opacity: 1;
  }

</style>
